import React, { Children } from 'react';
import { motion } from 'framer-motion';
const comparisons = [{
  situation: 'Sabés cuánto cobrar',
  without: 'Copiás al de al lado',
  withEco: 'Fórmula exacta según costos y sueldo deseado'
}, {
  situation: 'Captás nuevos alumnos',
  without: 'Dependés del boca a boca',
  withEco: 'Embudo: Instagram + WhatsApp + referidos + alianzas'
}, {
  situation: 'Cerrás inscripciones',
  without: 'Respondés y esperás',
  withEco: '3 mensajes que convierten consultas en inscriptos'
}, {
  situation: 'Delegás tareas',
  without: 'Todo depende de vos',
  withEco: 'Manual de onboarding + protocolo semanal'
}, {
  situation: 'Retenés alumnos +6 meses',
  without: '60% se va antes del año',
  withEco: 'Sistema de 5 palancas → retención 90%+'
}];
const modules = [{
  icon: '💰',
  title: 'Negocio y Finanzas',
  desc: 'Modelo de academia · Fórmula de precio · Dashboard financiero · Anti-morosidad'
}, {
  icon: '📣',
  title: 'Marketing y Captación',
  desc: 'Instagram orgánico · WhatsApp Business · Referidos · Alianzas · Meta Ads'
}, {
  icon: '🤝',
  title: 'Ventas y Conversión',
  desc: 'Script de cierre · 3 mensajes que inscriben · Clase de prueba gratuita'
}, {
  icon: '👥',
  title: 'Equipo y Operativa',
  desc: 'Perfil del asistente · Onboarding · 8 SOPs · Checklist diaria · Salarios'
}, {
  icon: '❤️',
  title: 'Retención de Alumnos',
  desc: '5 razones de abandono · 5 palancas de retención · Rituales de pertenencia'
}, {
  icon: '🚀',
  title: 'Escala y Documentos',
  desc: 'Segunda sede · Franquicia · Torneo propio · Contratos · Reglamentos'
}];
export function EliteSection() {
  return <section className="w-full bg-[#0a0a0a] py-14 sm:py-24 px-4 overflow-hidden" data-id="element-36">
      <div className="max-w-2xl mx-auto" data-id="element-37">
        <motion.div className="text-center mb-8 sm:mb-10" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5
      }} data-id="element-38">
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-black text-white mb-3 leading-tight" data-id="element-39">
            🏆 ¿Qué agrega{' '}
            <span className="text-[#22C55E]" data-id="element-40">Academia Élite 360</span>?
          </h2>
          <p className="text-gray-400 text-sm sm:text-lg max-w-lg mx-auto leading-relaxed" data-id="element-41">
            El Megapack resuelve tu entrenamiento. Academia Élite 360 te da el
            sistema para{' '}
            <strong className="text-gray-200" data-id="element-42">
              gestionar, crecer y escalar
            </strong>{' '}
            tu academia.
          </p>
        </motion.div>

        {/* Comparison Table */}
        <motion.div className="bg-white/[0.02] border border-[#22C55E]/20 rounded-2xl overflow-hidden mb-8 sm:mb-12 shadow-2xl" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} data-id="element-43">
          <div className="grid grid-cols-3 bg-black/60 border-b border-[#22C55E]/30" data-id="element-44">
            <div className="p-2.5 sm:p-4 font-bold text-white text-[11px] sm:text-sm" data-id="element-45">
              Situación
            </div>
            <div className="p-2.5 sm:p-4 font-bold text-gray-500 text-[11px] sm:text-sm text-center border-l border-white/5" data-id="element-46">
              Sin Élite 360
            </div>
            <div className="p-2.5 sm:p-4 font-bold text-[#22C55E] text-[11px] sm:text-sm text-center border-l border-[#22C55E]/20 bg-[#22C55E]/[0.03]" data-id="element-47">
              Con Élite 360
            </div>
          </div>

          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.06
            }
          }
        }} data-id="element-48">
            {comparisons.map((row, i) => <motion.div key={i} variants={{
            hidden: {
              opacity: 0,
              x: -10
            },
            visible: {
              opacity: 1,
              x: 0,
              transition: {
                duration: 0.3
              }
            }
          }} className="grid grid-cols-3 border-b border-white/5 last:border-b-0 hover:bg-white/[0.02] transition-colors" data-id="element-49">
                <div className="p-2.5 sm:p-4 text-gray-300 text-[11px] sm:text-sm flex items-center" data-id="element-50">
                  {row.situation}
                </div>
                <div className="p-2.5 sm:p-4 text-gray-500 text-[11px] sm:text-sm border-l border-white/5 flex items-center justify-center text-center" data-id="element-51">
                  {row.without}
                </div>
                <div className="p-2.5 sm:p-4 text-[#22C55E]/90 font-medium text-[11px] sm:text-sm border-l border-[#22C55E]/10 bg-[#22C55E]/[0.02] flex items-center justify-center text-center" data-id="element-52">
                  {row.withEco}
                </div>
              </motion.div>)}
          </motion.div>
        </motion.div>

        {/* Modules Grid */}
        <motion.div className="relative bg-[#22C55E]/[0.03] border border-[#22C55E]/15 rounded-2xl p-4 sm:p-6 overflow-hidden" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-53">
          <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#22C55E]/40 to-transparent" data-id="element-54" />

          <div className="flex items-center justify-center gap-3 mb-4 sm:mb-5" data-id="element-55">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent to-[#22C55E]/20" data-id="element-56" />
            <h3 className="text-[#22C55E] text-sm sm:text-lg font-black tracking-wide whitespace-nowrap" data-id="element-57">
              ✅ ÉLITE 360 INCLUYE
            </h3>
            <div className="h-px flex-1 bg-gradient-to-l from-transparent to-[#22C55E]/20" data-id="element-58" />
          </div>

          <motion.div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-3" initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-40px'
        }} variants={{
          hidden: {},
          visible: {
            transition: {
              staggerChildren: 0.07
            }
          }
        }} data-id="element-59">
            {modules.map((mod, i) => <motion.div key={i} variants={{
            hidden: {
              opacity: 0,
              y: 12
            },
            visible: {
              opacity: 1,
              y: 0,
              transition: {
                duration: 0.35,
                ease: 'easeOut'
              }
            }
          }} className="flex items-start gap-2.5 sm:gap-3 rounded-xl px-3 sm:px-4 py-2.5 sm:py-3 bg-white/[0.02] border border-white/[0.04] hover:border-[#22C55E]/20 hover:bg-white/[0.04] transition-all duration-300" data-id="element-60">
                <span className="flex-shrink-0 w-8 h-8 sm:w-9 sm:h-9 rounded-lg bg-[#22C55E]/[0.08] flex items-center justify-center text-base sm:text-lg" data-id="element-61">
                  {mod.icon}
                </span>
                <div className="min-w-0 flex-1" data-id="element-62">
                  <p className="text-white text-xs sm:text-sm font-bold leading-snug mb-0.5" data-id="element-63">
                    {mod.title}
                  </p>
                  <p className="text-gray-500 text-[10px] sm:text-xs leading-snug" data-id="element-64">
                    {mod.desc}
                  </p>
                </div>
              </motion.div>)}
          </motion.div>
        </motion.div>
      </div>
    </section>;
}